import { useAuthStore } from "@/pages/Login/store";
import { logoutHandler } from "@/auth/logout";
import { paths } from "@/navigation/paths";

export function useAuth() {
  const isLoggedIn = useAuthStore((s) => s.isLoggedIn);
  const user = useAuthStore((s) => s.user);

  return {
    isLoggedIn,
    user,
    logout: logoutHandler,
    loginPath: paths.LOGIN,
  } as const;
}
